<app-accept-terms-and-conditions />
<div class="layout-wrapper" [ngClass]="containerClass">
  <app-topbar />
  <app-sidebar />

  <div class="layout-main-container">
    <div class="layout-main">
      <app-announcements />
      <router-outlet />
      <app-no-subscription-overlay />
    </div>
  </div>

  <div
    class="layout-mask"
    tabindex="0"
    role="button"
    (click)="layoutService.onMenuToggle()"
    (keyup)="($event.key === 'Enter' || $event.key === ' ') && layoutService.onMenuToggle()"
  ></div>
</div>
